import { create } from "zustand"

export type SeveridadeMensagem = "error" | "warning"

export type MensagemDialog = {
    id: number
    texto: string
    severidade: SeveridadeMensagem
}

export type DialogMensagemStoreType = {
    fila: MensagemDialog[]
    mostrar: (texto: string, severidade: SeveridadeMensagem) => void
    fecharAtual: () => void
    limpar: () => void
}

let proximoId = 1

const useDialogMensagemStore = create<DialogMensagemStoreType>()((set) => ({
    fila: [],
    mostrar: (texto, severidade) =>
        set((estado) => {
            // Uma falha costuma disparar a mesma mensagem várias vezes (retry, vários
            // itens do mesmo lote). Sem isto o usuário teria que dar OK N vezes no
            // mesmo texto. Compara com a fila inteira, não só com a atual.
            const jaNaFila = estado.fila.some(
                (m) => m.texto === texto && m.severidade === severidade
            )
            if (jaNaFila) return estado
            return { fila: [...estado.fila, { id: proximoId++, texto, severidade }] }
        }),
    fecharAtual: () => set((estado) => ({ fila: estado.fila.slice(1) })),
    limpar: () => set({ fila: [] }),
}))

export default useDialogMensagemStore
